import { resultsPage } from "./constants";

const titleHome = "Agenda y estadísticas de fútbol";
const descriptionHome =
    "Consultá resultados y estadísticas en Clarín: Posiciones, fixtures, horarios y partidos de fútbol hoy en vivo.";

/** Opta manda los clubes con el prefijo societario; para el título se saca. */
const clubPrefixes = /\b(CR|SE|CA|SC|FC|SA|AF|CFP|CF|CSD|Club|Clube|EC|SdE)\b/g;
const teamName = (contestant) => contestant?.name.replace(clubPrefixes, "");

export const getTitle = (page, competition, team, match) => {
    switch (page) {
        case resultsPage.home:
            return titleHome;
        case resultsPage.team:
            if (!team?.contestant) {
                return titleHome;
            }
            return `Resultados y partidos de ${team?.contestant[0]?.name}`;
        case resultsPage.match:
            if (!match?.matchInfo?.description) {
                return titleHome;
            }
            return `Estadísticas y resultado | ${teamName(match?.matchInfo?.contestant[0])} vs. ${teamName(
                match?.matchInfo?.contestant[1]
            )}`;
        default:
            if (!competition) {
                return titleHome;
            }
            return `Tablas y estadísticas ${competition}`;
    }
};

export const getMetaDescription = (page, competition, team, match) => {
    switch (page) {
        case resultsPage.home:
            return descriptionHome;
        case resultsPage.team:
            if (!team?.contestant) {
                return descriptionHome;
            }
            return `Encontrá toda la información sobre resultados y partidos de ${team?.contestant[0]?.name}: Consultá en Clarín posiciones, fixtures y estadísticas en vivo.`;
        case resultsPage.match:
            if (!match?.matchInfo?.localDate) {
                return descriptionHome;
            }
            return `Encontrá todas las estadísticas del partido por la ${competition} entre ${teamName(
                match?.matchInfo?.contestant[0]
            )} y ${teamName(match?.matchInfo?.contestant[1])}: En vivo, el resumen de goles y jugadas destacadas.`;
        default:
            if (!competition) {
                return descriptionHome;
            }
            return `Encontrá todas las estadísticas de partidos, posiciones y goleadores de la ${competition}: Seguí el fixture completo y resultados en vivo.`;
    }
};
